import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Segment, Header, Icon, Grid, Input, Message } from 'semantic-ui-react';

import './AcceptedBidsContainer.less';

import BidsPartial from './AcceptedBidsPartial';

import { setActiveMenuItem } from '../../store/actions/actions';
import { getSellerServices } from '../../services/Services';
import { getAcceptedBids, getAcceptanceCodes } from '../../services/Project';
import RequestDetailsModal from '../../components/RequestDetailsModal/RequestDetailsModal';

class AcceptedBidsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            acceptanceCodes: [],
            acceptanceCode: '',
            acceptanceCodeError: '',
            appliedAcceptanceCode: '',
            showDetailsModal: false
        }
    }

    async componentDidMount() {
        this.props.setActiveMenuItem('accepted-bids');
        const servicesPromise =  getSellerServices().then((res) => {
            return res.data || [];
        });
        const acceptanceCodesPromise =  getAcceptanceCodes().then((res) => {
            return res.data || [];
        });
        const [services, acceptanceCodes] = await Promise.all([servicesPromise, acceptanceCodesPromise])
        await this.setState({ services, acceptanceCodes });
    }

    onAcceptanceCodeChange = async (e, d) => {
        if (d.value.length > 5) {
            return null;
        }
        let acceptanceCodeError = '';
        this.setState({ acceptanceCode: d.value, acceptanceCodeError });
        const acceptanceCodesPromise =  getAcceptanceCodes({ acceptanceCode: d.value }).then((res) => {
            return res.data || [];
        });
        const [acceptanceCodes] = await Promise.all([acceptanceCodesPromise])
        if (!acceptanceCodes.length) {
            acceptanceCodeError = 'No code matched.';
        }
        await this.setState({ acceptanceCodes, acceptanceCodeError });
    }

    searchByCode = async () => {
        const { acceptanceCode } = this.state;
        this.setState({ appliedAcceptanceCode: acceptanceCode });
    }

    render() {
        const { services, appliedAcceptanceCode, acceptanceCode, acceptanceCodes, acceptanceCodeError } = this.state;
        const visitTime = this.props.location.state && this.props.location.state.visitTime;

        return (
            <div className="AcceptedBidsContainer animated fadeInRight">
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h1">
                            <Header.Content>
                                <Icon name='handshake' size='small' />
                                Leads
                            </Header.Content>
                        </Header>
                    </Segment>
                    
                </Segment.Group>
                <Grid celled>
                   
                    <Grid.Row>
                        <Grid.Column>
                            {/*<Input
                                value={acceptanceCode}
                                list="acceptanceCodes"
                                action={{ content: 'Search', onClick: this.searchByCode }}
                                placeholder='Acceptance Code'
                                onChange={(e, d) => this.onAcceptanceCodeChange(e, d)}
                                onKeyUp={(e, d) => {
                                    if(e.key === 'Enter') {
                                        this.searchByCode();
                                    }
                                }}
                            />
                            <datalist id="acceptanceCodes">
                                {
                                    acceptanceCodes.map(ac => (
                                        <option key={ac.sellerBidHistoryID} value={ac.acceptanceCode} />
                                    ))
                                }
                            </datalist>
                            {acceptanceCodeError && (<Message negative>
                                <p>{acceptanceCodeError}</p>
                            </Message>)}
                            */}
                            
                            {services.map((service, i) => {
                                return (
                                    <BidsPartial service={service}
                                        getRequests={getAcceptedBids}
                                        appliedAcceptanceCode={appliedAcceptanceCode}
                                        key={`service${i}`} history={this.props.history}
                                        visitTime={visitTime}
                                        setSBRID={(sbrID) => this.setState({ sbrID, showDetailsModal: true}) }
                                    />
                                )
                            })}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <RequestDetailsModal
                    closeHandler={() => this.setState({ showDetailsModal: false })}
                    open={this.state.showDetailsModal}
                    type='expiring'
                    singleBuyerRequestID={this.state.sbrID}
                />
            </div>
        );
    }
}

function mapStateToProps({}) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setActiveMenuItem
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AcceptedBidsContainer);